import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Floor } from '@era/locations-sdk';

// ============================================================================
// FLOOR STATE
// ============================================================================
// Note: We will step away from using these state in the future, so don't
// add new ones or build upon them.
// ============================================================================

export type FloorState = EntityState<Floor>;

export function selectFloorIdFromFloor(floor: Floor) {
  return `${floor.locationId}-${floor.id}`; // TODO, add brandId
}

export function sortByDisplayName(a: Floor, b: Floor): number {
  return a.displayName.localeCompare(b.displayName, 'en', { numeric: true });
}

export const adapter: EntityAdapter<Floor> = createEntityAdapter<Floor>({
  selectId: selectFloorIdFromFloor,
  sortComparer: sortByDisplayName,
});

export const initialState: FloorState = adapter.getInitialState();
